__turbopack_context__.v({
  "aligned-row": "style-module-scss-module__N-jXPG__aligned-row",
  "button-wrapper": "style-module-scss-module__N-jXPG__button-wrapper",
  "car": "style-module-scss-module__N-jXPG__car",
  "city-address": "style-module-scss-module__N-jXPG__city-address",
  "component": "style-module-scss-module__N-jXPG__component",
  "contact-for-price": "style-module-scss-module__N-jXPG__contact-for-price",
  "courtesy": "style-module-scss-module__N-jXPG__courtesy",
  "description": "style-module-scss-module__N-jXPG__description",
  "desktop-listing-time": "style-module-scss-module__N-jXPG__desktop-listing-time",
  "favourite-toggle-wrapper": "style-module-scss-module__N-jXPG__favourite-toggle-wrapper",
  "left": "style-module-scss-module__N-jXPG__left",
  "listed-since": "style-module-scss-module__N-jXPG__listed-since",
  "listing-status": "style-module-scss-module__N-jXPG__listing-status",
  "mls-courtesy-row": "style-module-scss-module__N-jXPG__mls-courtesy-row",
  "mls-number": "style-module-scss-module__N-jXPG__mls-number",
  "mobile-only": "style-module-scss-module__N-jXPG__mobile-only",
  "mobile-status": "style-module-scss-module__N-jXPG__mobile-status",
  "modal-status": "style-module-scss-module__N-jXPG__modal-status",
  "price-history": "style-module-scss-module__N-jXPG__price-history",
  "price-time-row": "style-module-scss-module__N-jXPG__price-time-row",
  "price-virtual-tour-section": "style-module-scss-module__N-jXPG__price-virtual-tour-section",
  "pvr-cta-button": "style-module-scss-module__N-jXPG__pvr-cta-button",
  "pvr-cta-wrapper": "style-module-scss-module__N-jXPG__pvr-cta-wrapper",
  "red-text": "style-module-scss-module__N-jXPG__red-text",
  "right": "style-module-scss-module__N-jXPG__right",
  "row": "style-module-scss-module__N-jXPG__row",
  "see-full-listing": "style-module-scss-module__N-jXPG__see-full-listing",
  "see-full-listing-container": "style-module-scss-module__N-jXPG__see-full-listing-container",
  "stat": "style-module-scss-module__N-jXPG__stat",
  "stats-container": "style-module-scss-module__N-jXPG__stats-container",
  "status-row": "style-module-scss-module__N-jXPG__status-row",
  "time-remaining": "style-module-scss-module__N-jXPG__time-remaining",
  "white": "style-module-scss-module__N-jXPG__white",
});
